import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(default)/error.tsx");
